import moment from "moment";
import affiliation from "../../../shared/fixtures/affiliation";
import deductibility from "../../../shared/fixtures/deductibility";
import eo_subsection from "../../../shared/fixtures/eo_subsection";
import exempt_org from "../../../shared/fixtures/exempt_org";
import filing_requirements from "../../../shared/fixtures/filing_requirements";
import income_code from "../../../shared/fixtures/income_code";
import months from "../../../shared/fixtures/months";
import Generics from "./Generics";

const Name = {
  type: "text",
  id: "name",
  name: "name",
  validation: {
    required: "Please enter your organization name.",
    minLength: {
      value: 2,
      message: "Please enter your organization name",
    },
  },
  placeholder: "E.g Social Safety Intl.",
  label: "Organization Name",
  required: true,
};

const AltName = {
  ...Name,
  id: "alternateName",
  name: "alternateName",
  label: "Alternate Name",
  placholder: "E.g Social Safety Corps",
  validation: {
    required: "Please enter your Alt Name.",
    minLength: {
      value: 2,
      message: "Please enter your Alt Name",
    },
  },
};

const Description = {
  rows: 3,
  id: "description",
  type: "textarea",
  name: "description",
  placeholder: "Describe the goal and mission of your organization",
  label: "Description",
  className: "w-full",
  required: true,
  validation: {
    required: "Please enter your description.",
    minLength: {
      value: 2,
      message: "Please enter your description",
    },
  },
};

const Tag = {
  ...Description,
  id: "tagline",
  name: "tagline",
  label: "Tagline",
  validation: {
    required: "Please enter your tagline.",
    minLength: {
      value: 2,
      message: "Please enter your tagline",
    },
  },
};

export const ContactFields = (key) => {
  return [
    {
      ...Generics.FirstName,
      name: `contact_firstName_${key}`,
      id: `contact_firstName_${key}`,
      validation: {
        required: "Please enter contact's first name.",
      },
      required: true,
    },
    {
      ...Generics.LastName,
      name: `contact_lastName_${key}`,
      id: `contact_lastName_${key}`,
      validation: {
        required: "Please enter contact's last name.",
      },
      required: true,
    },
    {
      type: "text",
      id: `contact_title_${key}`,
      name: `contact_title_${key}`,
      placeholder: "Mr, Mrs, Dr",
      label: "Title",
      containerClass: "flex_grow",
    },
    {
      type: "text",
      id: `contact_department_${key}`,
      name: `contact_department_${key}`,
      placeholder: "Enter department",
      label: "Department",
      containerClass: "flex_grow",
    },
    {
      ...Generics.Email,
      name: `contact_email_${key}`,
      id: `contact_email_${key}`,
      required: true,
    },
  ];
};

export const LocationFields = (key) => {
  return [
    {
      type: "text",
      name: `location_name_${key}`,
      id: `location_name_${key}`,
      validation: {
        required: "Please enter location name.",
      },
      placeholder: "Enter location name",
      label: "Name",
      required: true,
    },
    {
      type: "text",
      name: `location_address_${key}`,
      id: `location_address_${key}`,
      validation: {
        required: "Please enter address.",
      },
      placeholder: "Enter location address",
      label: "Address",
      required: true,
    },
    {
      type: "Country",
      id: `location_country_${key}`,
      name: `location_country_${key}`,
      validation: { required: "Select a country" },
      required: true,
    },
    {
      type: "text",
      name: `location_region_${key}`,
      id: `location_region_${key}`,
      placeholder: "Enter location Reion",
      label: "Region",
    },
    {
      type: "State",
      id: `location_stateOrProvince_${key}`,
      name: `location_stateOrProvince_${key}`,
      country: `location_country_${key}`,
      validation: { required: "Select a state" },
      required: true,
    },
    {
      type: "City",
      id: `location_city_${key}`,
      name: `location_city_${key}`,
      _state: `location_stateOrProvince_${key}`,
    },
    {
      type: "number",
      id: `location_zipCode_${key}`,
      name: `location_zipCode_${key}`,
      placeholder: "e.g 500212",
      label: "Zip Code",
      validation: { required: "Enter zip code" },
      containerClass: "flex_grow",
      required: true,
    },
    {
      type: "Language",
      label: "Languages",
      isMulti: true,
      id: `location_languages_${key}`,
      name: `location_languages_${key}`,
      validation: {
        required: "Select at least one language",
        validate: (value) => Array.isArray(value) && value.length > 0,
      },
    },
  ];
};

export const Phones = (key) => {
  return [
    {
      type: "tel",
      id: `phone_number_${key}`,
      name: `phone_number_${key}`,
      validation: {
        required: "Please enter phone number.",
      },
      placeholder: "Enter phone number",
      label: "Number",
      containerClass: "flex-grow",
      required: true,
    },
    {
      type: "PhoneExtension",
      id: `phone_extension_${key}`,
      name: `phone_extension_${key}`,
      validation: { required: "Select an extension" },
    },
    {
      type: "PhoneType",
      id: `phone_type_${key}`,
      name: `phone_type_${key}`,
      validation: { required: "Select a type" },
    },
    {
      type: "Language",
      label: "Language",
      isMulti: false,
      id: `phone_language_${key}`,
      name: `phone_language_${key}`,
      defaultValue: "",
      validation: {
        required: "Select a language",
      },
      required: true,
    },
  ];
};

export const BasicDetailsFields = [
  Name,
  {
    ...AltName,
    required: false,
    placeholder: "E.g Social Safety Corps",
    validation: {
      required: false,
    },
  },
  Description,
  {
    ...Tag,
    placeholder: "Your organization tagline E.g Changing lives, one step at a time",
    required: false,
    validation: {
      required: false,
    },
  },
  {
    ...Generics.Email,
    required: true,
  },
  {
    ...Generics.URL,
    required: true,
  },
];

export const TaxDetailsFields = [
  {
    type: "tel",
    id: "ein",
    name: "ein",

    validation: {
      pattern: {
        message: "Please enter a valid ein",
      },
    },
    placeholder: "",
    label: "EIN",
    // marginBottom: "0",
  },
  {
    type: "Select",
    id: `deductibility`,
    name: `deductibility`,
    label: "Deductibility",
    options: deductibility,
  },
  {
    type: "Select",
    id: `eo_subsection`,
    name: `eo_subsection`,
    label: "Subsection",
    options: eo_subsection,
  },
  {
    type: "Select",
    id: `asset_amount`,
    name: `asset_amount`,
    label: "Asset Amount",
    options: income_code,
  },
  {
    type: "Select",
    id: `income_amount`,
    name: `income_amount`,
    label: "Income Amount",
    options: income_code,
  },
  {
    type: "Select",
    id: `filing_requirements`,
    name: `filing_requirements`,
    label: "Filing Requirements",
    options: filing_requirements,
  },
  {
    type: "date",
    id: "latest990",
    name: "latest990",
    color: "#F8F6FE",
    className: "py-1 px-2",
    validation: {
      validate: (value) =>
        value === "" ||
        moment(value).isSameOrBefore(moment()) ||
        "Enter a date before today",
    },
    label: "Latest 990",
    placeholder: "dd-mm-yyyy",
    inputClassName: "-ml-3",
    // marginBottom: "0",
  },
  {
    type: "date",
    id: "rulingDate",
    name: "rulingDate",
    color: "#F8F6FE",
    className: "py-1 px-2",
    validation: {
      validate: (value) =>
        value === "" ||
        moment(value).isSameOrBefore(moment()) ||
        "Enter a date before today",
    },
    label: "Ruling Date",
    placeholder: "dd-mm-yyyy",
    inputClassName: "-ml-3",
    // marginBottom: "0",
  },
  {
    type: "Select",
    id: `affiliation`,
    name: `affiliation`,
    label: "Affiliation",
    options: affiliation,
  },
  {
    type: "Select",
    id: `accountingPeriod`,
    name: `accountingPeriod`,
    label: "Accounting Period",
    options: months,
  },
  {
    type: "Select",
    id: `exemptOrg`,
    name: `exemptOrg`,
    label: "Exempt Organization",
    options: exempt_org,
  },
];
